import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";

export const StatusContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  borderRadius: 8,
  backgroundColor: "#ffffff",
  maxWidth: "650px",
  margin: "0 auto",
  "& > img": {
    width: "460px"
  }
}));

export const FailedResult = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  rowGap: "24px",
  [theme.breakpoints.up("sm")]: {
    rowGap: "48px"
  }
}));

export const Container = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  rowGap: "24px",
  fontSize: "30px !important",
  [theme.breakpoints.up("sm")]: {
    rowGap: "40px"
  },
  "& img": {
    width: 85,
    height: "auto",
    marginBottom: 20,
    [theme.breakpoints.up("lg")]: {
      width: 120,
      height: 126,
      marginBottom: 40
    }
  },
  "& button": {
    borderRadius: "1000px",
    padding: "12px 24px",
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "24px",
    "&.MuiButton-outlined": {
      border: "1px solid var(--colour-outline-dark, #1A1A1A)",
      background: "#fff",
      "& .labelStyle": {
        color: "var(--colour-text-primary, #000)"
      }
    }
  }
}));

export const FailedIcon = styled("div")(({ theme }) => ({
  display: "none",
  [theme.breakpoints.up("sm")]: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "72px",
    height: "72px",
    borderRadius: "50%",
    backgroundColor: "var(--Color-Alert-Icon-Error, #5E080B)",
    "& svg": {
      width: "24px",
      height: "24px",
      color: "var(--colour-text-text_light, #fff)"
    }
  }
}));

export const TitleContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  rowGap: "8px",
  [theme.breakpoints.up("sm")]: {
    alignItems: "center",
    textAlign: "center"
  }
}));

export const Title = styled("h3")(({ theme }) => ({
  margin: 0,
  fontSize: "28px",
  lineHeight: "36px",
  fontWeight: 500,
  color: "var(--colour-text-primary, #000)",
  [theme.breakpoints.up("sm")]: {
    fontSize: "52px",
    lineHeight: "68px",
    fontWeight: 600
  }
}));

export const Subtitle = styled("p")(({ theme }) => ({
  fontSize: "14px",
  lineHeight: "20px",
  fontWeight: 400,
  margin: 0,
  color: "var(--Color-Text-Secondary-On-Light, #757575)",
  [theme.breakpoints.up("sm")]: {
    fontSize: "20px",
    lineHeight: "28px"
  }
}));

export const StatusContainerNoIcon = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
  height: "100%",
  width: "100%",
  borderRadius: 8,
  backgroundColor: "#ffffff",
  maxWidth: "650px",
  margin: "0 auto",
  [theme.breakpoints.up("lg")]: {
    height: "100vh"
  }
}));

export const MessageContainer = styled(Box)(({ theme }) => ({
  boxSizing: "border-box",
  maxWidth: "609px",
  textAlign: "center",
  color: "#373737",
  fontSize: 20,
  lineHeight: 1.5,
  "& > p": {
    marginBottom: "27px"
  }
}));

export const StatusText = styled(Typography)(({ theme }) => ({
  boxSizing: "border-box",
  maxWidth: "609px",
  textAlign: "center",
  color: "#373737",
  fontSize: 20,
  lineHeight: 1.5,
  marginBottom: "27px"
}));

export const StatusTextNoIcon = styled(Typography)(({ theme }) => ({
  boxSizing: "border-box",
  maxWidth: "609px",
  textAlign: "center",
  color: "#373737",
  fontSize: 20,
  lineHeight: 1.5,
  fontWeight: "600"
}));

export const LinkContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  color: "#373737",
  border: "solid 1px #373737",
  padding: "3px 9px",
  fontSize: 14,
  margin: "5px",
  borderRadius: 21,
  display: "block",
  textDecoration: "none",
  transition: "all 0.2s ease",
  "&:hover": {
    backgroundColor: "#373737",
    color: "#fff"
  }
}));

export const Result = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  rowGap: "40px"
}));

export const FormActions = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column-reverse",
  gap: "24px",
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    flexDirection: "row"
  }
}));

export const loanDeclineLabel = {
  marginTop: 15,
  textAlign: "left",
  marginBottom: 0
};

export const infoText = {
  fontSize: "20px",
  marginTop: 15
};

export const dialogButtonContainer = {
  flexDirection: "column",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "15px"
};

export const dialogContent = {
  textAlign: "center",
  fontSize: "20px",
  marginTop: "10%"
};

export const keyframesRotate = {
  "100%": {
    transform: "rotate(360deg)"
  }
};

export const loader = {
  width: "24px",
  height: "24px",
  margin: "0 auto",
  animation: "$rotate 2s linear infinite",
  fill: "gray"
};
